import React, { createContext, useContext } from 'react';

import type { ExecuteToolFn } from 'js/src/agent/types';

export interface SketchContextValue {
    sendMessage: (message: string) => Promise<boolean>;
    executeTool: ExecuteToolFn;
}

const SketchContext = createContext<SketchContextValue | null>(null);

export const SketchContextProvider: React.FC<{
    sendMessage: (message: string) => Promise<boolean>;
    executeTool: ExecuteToolFn;
    children: React.ReactNode;
}> = ({ sendMessage, executeTool, children }) => {
    const value = React.useMemo(() => ({ sendMessage, executeTool }), [sendMessage, executeTool]);
    return <SketchContext value={value}>{children}</SketchContext>;
};

export function useSketchContext(): SketchContextValue | null {
    return useContext(SketchContext);
}

export function useSendMessage(): ((message: string) => Promise<boolean>) | null {
    const context = useSketchContext();
    return context?.sendMessage ?? null;
}

export function useExecuteTool(): ExecuteToolFn | null {
    const context = useSketchContext();
    return context?.executeTool ?? null;
}
